import { useEffect, useState } from "react";
import { Shell, Card } from "../components/Layout";
import { http } from "../lib/api";

const P = ({ children }) => <p className="mt-4 text-lg leading-relaxed text-ink-700">{children}</p>;
const H = ({ children }) => <h2 className="mt-8 font-head text-2xl font-medium">{children}</h2>;

export function Privacidad() {
  return (
    <Shell title="Política de Privacidad" testid="privacy-page">
      <Card className="max-w-4xl">
        <H>Responsable del tratamiento</H>
        <P>SISU — Centro de Estudios y Logopedia (sedes de Xaló y Dénia). Puede dirigirse a
          nosotros en academiasisu@gmail.com para cualquier cuestión relativa a sus datos.</P>
        <H>Finalidad del tratamiento</H>
        <P>Gestionar la matrícula y el horario del alumnado del Centro de Estudios, la reserva y
          seguimiento de las sesiones de Logopedia, el envío de recordatorios de clase o sesión por
          WhatsApp, el control de asistencia y recuperaciones, y la gestión administrativa de
          mensualidades y bonos. En Logopedia se tratan además datos de salud recogidos en la
          anamnesis, con la finalidad exclusiva de la intervención logopédica.</P>
        <H>Base jurídica</H>
        <P>El consentimiento del padre, madre o tutor legal (art. 6.1.a y art. 9.2.a RGPD para datos
          de salud) y la ejecución de la relación de servicios. Al tratarse de menores, el
          consentimiento lo presta siempre quien ejerce la patria potestad o tutela, conforme al
          art. 7 de la LOPDGDD (Ley Orgánica 3/2018).</P>
        <H>Datos de menores y datos de salud</H>
        <P>Los datos clínicos recogidos en la anamnesis se consideran categoría especial de datos y
          reciben un nivel de protección reforzado: acceso limitado al profesional de logopedia y al
          equipo de SISU, sin cesión a terceros salvo obligación legal.</P>
        <H>Plazo de conservación</H>
        <P>Los datos académicos se conservan mientras el alumno esté matriculado y, después, durante
          los plazos legales de conservación administrativa y fiscal. La documentación clínica de
          logopedia se conserva según la normativa sanitaria aplicable (mínimo 5 años desde el alta
          del proceso).</P>
        <H>Destinatarios</H>
        <P>No se ceden datos a terceros, salvo el proveedor tecnológico de mensajería utilizado para
          enviar los recordatorios por WhatsApp, que actúa como encargado del tratamiento.</P>
        <H>Derechos de las personas interesadas</H>
        <P>Puede ejercer los derechos de acceso, rectificación, supresión, oposición, limitación
          del tratamiento y portabilidad dirigiéndose a academiasisu@gmail.com, adjuntando documento
          identificativo. Asimismo, puede presentar una reclamación ante la Agencia Española de
          Protección de Datos (www.aepd.es).</P>
      </Card>
    </Shell>
  );
}

export function AvisoLegal() {
  return (
    <Shell title="Aviso Legal" testid="legal-page">
      <Card className="max-w-4xl">
        <H>Titular del sitio web</H>
        <P>SISU — Centro de Estudios y Logopedia. Sedes en Xaló y Dénia (Alicante). Contacto:
          academiasisu@gmail.com. Información facilitada en cumplimiento del art. 10 de la Ley
          34/2002 (LSSI-CE).</P>
        <H>Condiciones de uso</H>
        <P>El acceso a esta web es gratuito. El uso del área privada requiere registro con datos
          veraces. La persona usuaria se compromete a hacer un uso correcto de la web y a no
          utilizarla con fines ilícitos. Los contenidos de la web son titularidad de SISU.</P>
        <H>Sin pagos en línea</H>
        <P>Esta web no gestiona pagos. Las mensualidades del Centro de Estudios y los bonos de
          Logopedia se abonan por los medios habituales del centro; la web solo refleja el estado
          informado por SISU.</P>
        <H>Política de cookies</H>
        <P>Esta web utiliza únicamente cookies técnicas necesarias para mantener la sesión de
          usuario iniciada. No se utilizan cookies de analítica, publicidad ni perfilado, por lo que
          no se requiere consentimiento previo para su instalación.</P>
        <H>Legislación aplicable</H>
        <P>Esta web se rige por la legislación española. Cualquier controversia se someterá a los
          juzgados y tribunales competentes.</P>
      </Card>
    </Shell>
  );
}

export function PoliticaCentro() {
  const sections = [
    ["Horario y organización",
      "El centro organiza sus clases por grupos según etapa y curso, en franjas horarias fijas de " +
      "lunes a viernes. Cada alumno se matricula en las franjas que mejor se adapten a su " +
      "disponibilidad, dentro de los límites establecidos para cada modalidad (grupo grande o " +
      "Grupo Reducido)."],
    ["Bloques de trabajo en ESO",
      "Las sesiones de ESO se organizan en dos bloques: Letras (Valenciano, Castellano e Inglés) y " +
      "Ciencias (Matemáticas, Física y Química, Biología). El horario indica qué bloque corresponde " +
      "a cada sesión."],
    ["Ausencias y recuperación de clases",
      "Si un alumno no va a asistir a una clase, la familia debe comunicarlo desde su área privada " +
      "antes de la sesión. Las ausencias comunicadas con antelación pueden recuperarse en otra " +
      "franja disponible dentro de su misma etapa y antes de que finalice el mes; pasado ese plazo, " +
      "la clase no es recuperable. Las ausencias no comunicadas se contabilizan como clase asistida."],
    ["Cambios de horario",
      "Las familias pueden solicitar un cambio de franja en cualquier momento, siempre que haya " +
      "disponibilidad y dentro del mismo grupo de edad/etapa del alumno."],
    ["Mensualidad y forma de pago",
      "La mensualidad se abona dentro de los primeros 15 días de cada mes, por los medios habituales " +
      "del centro. La web únicamente refleja si el pago está realizado o pendiente; no se gestiona " +
      "ningún cobro a través de ella."],
    ["Baja voluntaria",
      "Cualquier familia puede darse de baja del centro en el momento que lo desee, directamente " +
      "desde su área privada, sin necesidad de solicitarlo previamente al equipo."],
    ["Salud y convivencia",
      "Por el bienestar de todo el alumnado, el centro dispone de mascarillas para su uso en caso de " +
      "que un alumno presente síntomas leves (tos, resfriado, etc.) durante su estancia. En casos " +
      "que lo requieran, el centro se reserva el derecho a pedir a la familia que el alumno no " +
      "asista ese día, con el fin de proteger la salud del resto del grupo, conforme a la autonomía " +
      "de organización interna que asiste a los centros privados (art. 1255 del Código Civil) y " +
      "siguiendo las recomendaciones habituales de salud pública en materia de prevención de " +
      "contagios en entornos con menores."],
    ["Protección de datos",
      "El tratamiento de los datos personales de los alumnos y sus familias se rige por el RGPD " +
      "(Reglamento UE 2016/679) y la Ley Orgánica 3/2018 de Protección de Datos Personales y " +
      "garantía de los derechos digitales. Puede consultarse la política de privacidad completa en " +
      "el pie de página de la web."],
  ];

  return (
    <Shell accent="centro" title="Política del Centro de Estudios SISU" testid="policy-page">
      <Card className="max-w-4xl">
        <div className="space-y-8">
          {sections.map(([title, text]) => (
            <section key={title} data-testid={`policy-section-${title.toLowerCase().replace(/\s+/g, "-")}`}>
              <h2 className="font-head text-lg font-medium text-ink-900 md:text-lg">{title}</h2>
              <p className="mt-2 text-lg text-ink-700">{text}</p>
            </section>
          ))}
        </div>
      </Card>
    </Shell>
  );
}

export function Calendario() {
  const [closures, setClosures] = useState([]);
  useEffect(() => {
    http.get("/closures").then(({ data }) => setClosures(data));
  }, []);
  return (
    <Shell title="Días de cierre del centro"
      subtitle="El centro sigue el calendario escolar de la Comunidad Valenciana, salvo en Fallas, período en el que permanece abierto."
      testid="calendar-page">
      <Card className="max-w-3xl">
        <div className="rounded-xl bg-centro-light p-5 text-lg text-centro-text">
          El presente curso el centro permanecerá cerrado igualmente el lunes 19 y el martes 20 de
          octubre, con motivo de las fiestas de la Mare de Déu Pobra.
        </div>
        <ul className="mt-6 divide-y divide-border" data-testid="closures-list">
          {closures.map((c) => (
            <li key={c.id} className="flex flex-wrap justify-between gap-2 py-4 text-lg">
              <span className="font-medium">{c.date}</span>
              <span className="text-ink-700">{c.reason}</span>
            </li>
          ))}
          {closures.length === 0 && <li className="py-4 text-lg">No hay días de cierre publicados.</li>}
        </ul>
      </Card>
    </Shell>
  );
}
